var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormHelperText } from "@mui/material";
import { FormControl, FormLabel, MenuItem, Select } from "@mui/material";
import { useController } from "react-hook-form";
import { LocalizedCurrencyText } from "../LocalizedCurrency";
export const SingleSelect = (_a) => {
    var _b, _c, _d;
    var { control, label, name, options, helperText, required } = _a, rest = __rest(_a, ["control", "label", "name", "options", "helperText", "required"]);
    const _e = useController({
        name,
        control,
        defaultValue: [],
    }), _f = _e.field, { ref, value } = _f, inputProps = __rest(_f, ["ref", "value"]), { formState: { errors } } = _e;
    return (_jsxs(FormControl, Object.assign({ required: required }, { children: [_jsx(FormLabel, Object.assign({ sx: { fontWeight: "bold", pb: 1 } }, { children: label })), _jsx(Select, Object.assign({}, rest, inputProps, { value: value, inputRef: ref, error: !!(errors === null || errors === void 0 ? void 0 : errors[name]) }, { children: options.map((option) => (_jsxs(MenuItem, Object.assign({ value: option.value }, { children: [`${option.label} `, option.price ? _jsx(LocalizedCurrencyText, { value: option.price }) : null] }), option.value))) })), _jsx(FormHelperText, Object.assign({ error: (_b = !!(errors === null || errors === void 0 ? void 0 : errors[name])) !== null && _b !== void 0 ? _b : false, variant: "outlined" }, { children: (_d = (_c = errors === null || errors === void 0 ? void 0 : errors[name]) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : helperText }))] })));
};
